/* fixed height, so only the pages scroll while title and buttons stay in place */
.dialog {
	display: flex;
	flex-direction: column;
	height: calc(100dvh - 2 * var(--modal-viewport-padding-y));
}

.dialog .body {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	margin: var(--modal-inner-padding) 0;
}

.toolbar {
	display: flex;
	align-items: center;
	gap: var(--content-padding-small);
	margin-top: var(--content-padding-small);
}

.documentSelect {
	flex: 1;
	min-width: 0;
}

.position {
	white-space: nowrap;
	color: var(--text-muted);
}

/* with several documents the actions do not fit into one row on narrow windows */
.footer {
	flex-wrap: wrap;
}

.pages {
	display: flex;
	flex-direction: column;
	gap: var(--content-padding-large);
}

.page {
	display: block;
	width: 100%;
	height: auto;
	box-shadow: var(--modal-content-shadow);
}

/* printing needs a rendered document, so the frame is shrunk away instead of display: none */
.printFrame {
	position: fixed;
	right: 0;
	bottom: 0;
	width: 0;
	height: 0;
	border: 0;
}
